import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store'
import { Mutations, Actions } from '@/store/enums/StoreEnums'

import JwtService from '@/core/services/JwtService'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/dashboard',
    component: () => import('@/layout/Layout.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      {
        path: '/builder',
        name: 'builder',
        component: () => import('@/views/Builder.vue'),
      },
      {
        path: '/home',
        name: 'app-home',
        component: () => import('@/views/AppHome.vue'),
      },
      // {
      //   path: '/main',
      //   name: 'main',
      //   component: () => import('@/views/teacher/profile/Overview.vue'),
      // },
      {
        path: '/user/index',
        name: 'user',
        component: () => import('@/views/admin/User.vue'),
      },
      {
        path: '/user/aa',
        name: 'user-aa',
        component: () => import('@/views/admin/UserAA.vue'),
      },
      {
        path: '/user/aa/:uid',
        name: 'user-aa-detail',
        component: () => import('@/views/admin/UserAaDetail.vue'),
      },
      {
        path: '/teacher/index',
        name: 'teacher',
        component: () => import('@/views/admin/TeacherPoint.vue'),
      },
      {
        path: '/tpoint/index',
        name: 'teacherconf',
        component: () => import('@/views/admin/TeacherPointConf.vue'),
      },
      {
        path: '/teacher/profile',
        name: 'teacherprofile',
        component: () => import('@/views/teacher/Profile.vue'),
        children: [
          {
            path: 'overview',
            name: 'teacherprofile-overview',
            component: () => import('@/views/teacher/profile/Overview.vue'),
          },
          {
            path: 'info',
            name: 'teacherprofile-info',
            component: () => import('@/views/teacher/profile/Info.vue'),
          },
          {
            path: 'projects',
            name: 'teacherprofile-projects',
            component: () => import('@/views/teacher/profile/Projects.vue'),
          },
        ],
      },
      {
        path: '/teacher/changepass',
        name: 'teacher-changepass',
        component: () => import('@/views/teacher/ChangePassword.vue'),
      },
      {
        path: '/teacher/changeusername',
        name: 'teacher-changeusername',
        component: () => import('@/views/teacher/ChangeUsername.vue'),
      },
      {
        path: '/teacher/researchinfo',
        name: 'teacher-researchinfo',
        component: () => import('@/views/teacher/ResearchInfo.vue'),
      },
      {
        path: '/teacher/salary',
        name: 'teacher-salary',
        component: () => import('@/views/teacher/SalaryInfo.vue'),
      },
      {
        path: '/teacher/asset',
        name: 'teacher-asset',
        component: () => import('@/views/teacher/AssetInfo.vue'),
      },
      {
        path: '/teacher/consult',
        name: 'teacher-consult',
        component: () => import('@/views/teacher/ConsultInfo.vue'),
      },
      {
        path: '/teacher/schedule',
        name: 'teacher-schedule',
        component: () => import('@/views/teacher/Schedule.vue'),
      },
      {
        path: '/teacher/schedule/att',
        name: 'teacher-schedule-att',
        component: () => import('@/views/teacher/ScheduleAtt.vue'),
      },
      {
        path: '/teacher/commission',
        name: 'teacher-commission',
        component: () => import('@/views/teacher/Commission.vue'),
      },
      {
        path: '/teacher/euschedule',
        name: 'teacher-euschedule',
        component: () => import('@/views/teacher/EUSchedule.vue'),
      },
      {
        path: '/teacher/practice',
        name: 'teacher-practice',
        component: () => import('@/views/teacher/PracticePoint.vue'),
      },
      {
        path: '/teacher/havsralt',
        name: 'teacher-havsralt',
        component: () => import('@/views/teacher/Havsralt.vue'),
      },
      {
        path: '/teacher/credit',
        name: 'teacher-credit',
        component: () => import('@/views/teacher/TsagiinTootsoo.vue'),
      },
      {
        path: '/teacher/chart1',
        name: 'teacher-chart1',
        component: () => import('@/views/teacher/ChartReport1.vue'),
      },
      {
        path: '/teacher/chart2',
        name: 'teacher-chart2',
        component: () => import('@/views/teacher/ChartReport2.vue'),
      },
      //Оюутны дотуур байр
      {
        path: '/dormitory/index',
        name: 'dormitory',
        component: () => import('@/views/dormitory/Index.vue'),
      },
      {
        path: '/dormitory/geree/:id',
        name: 'dormitory-geree',
        component: () => import('@/views/dormitory/Geree.vue'),
      },
      //Сургалтын алба
      {
        path: '/training/tugsult',
        name: 'training-tugsult',
        component: () => import('@/views/training/Tugsult.vue'),
      },
      {
        path: '/training/toiroh',
        name: 'training-toiroh',
        component: () => import('@/views/training/Toiroh.vue'),
      },
      {
        path: '/menu',
        name: 'menu',
        component: () => import('@/views/admin/Menu.vue'),
      },
      {
        path: '/accessLevel',
        name: 'accessLevel',
        component: () => import('@/views/admin/AccessLevel.vue'),
      },
      {
        path: '/app',
        name: 'app',
        component: () => import('@/views/admin/System.vue'),
      },
      {
        path: '/role',
        name: 'role',
        component: () => import('@/views/admin/Role.vue'),
      },
      {
        path: '/operation',
        name: 'operation',
        component: () => import('@/views/admin/Operation.vue'),
      },
      {
        path: '/logtime',
        name: 'log-teacher',
        component: () => import('@/views/admin/lms/LogStatTeacher.vue'),
      },
      {
        path: '/logtimestudent',
        name: 'log-student',
        component: () => import('@/views/admin/lms/LogStatStudent.vue'),
      },
      {
        path: '/fileView',
        name: 'lms-fileview',
        component: () => import('@/views/admin/lms/FileView.vue'),
      },
      {
        path: '/filestat',
        name: 'log-filestat',
        component: () => import('@/views/admin/lms/FileStat.vue'),
      },
      {
        path: '/crafted/pages/profile',
        name: 'profile',
        component: () => import('@/components/page-layouts/Profile.vue'),
        children: [
          {
            path: 'overview',
            name: 'profile-overview',
            component: () => import('@/views/crafted/pages/profile/Overview.vue'),
          },
          {
            path: 'projects',
            name: 'profile-projects',
            component: () => import('@/views/crafted/pages/profile/Projects.vue'),
          },
          {
            path: 'campaigns',
            name: 'profile-campaigns',
            component: () => import('@/views/crafted/pages/profile/Campaigns.vue'),
          },
          {
            path: 'documents',
            name: 'profile-documents',
            component: () => import('@/views/crafted/pages/profile/Documents.vue'),
          },
          {
            path: 'connections',
            name: 'profile-connections',
            component: () => import('@/views/crafted/pages/profile/Connections.vue'),
          },
        ],
      },
      {
        path: '/crafted/pages/wizards/horizontal',
        name: 'horizontal-wizard',
        component: () => import('@/views/crafted/pages/wizards/Horizontal.vue'),
      },
      {
        path: '/crafted/pages/wizards/vertical',
        name: 'vertical-wizard',
        component: () => import('@/views/crafted/pages/wizards/Vertical.vue'),
      },
      {
        path: '/crafted/account',
        name: 'account',
        component: () => import('@/views/crafted/account/Account.vue'),
        children: [
          {
            path: 'overview',
            name: 'account-overview',
            component: () => import('@/views/crafted/account/Overview.vue'),
          },
          {
            path: 'settings',
            name: 'account-settings',
            component: () => import('@/views/crafted/account/Settings.vue'),
          },
        ],
      },
      {
        path: '/apps/customers/getting-started',
        name: 'apps-customers-getting-started',
        component: () => import('@/views/apps/customers/GettingStarted.vue'),
      },
      {
        path: '/apps/customers/customers-listing',
        name: 'apps-customers-listing',
        component: () => import('@/views/apps/customers/CustomersListing.vue'),
      },
      {
        path: '/apps/customers/customer-details',
        name: 'apps-customers-details',
        component: () => import('@/views/apps/customers/CustomerDetails.vue'),
      },
      {
        path: '/apps/calendar',
        name: 'apps-calendar',
        component: () => import('@/views/apps/Calendar.vue'),
      },
      {
        path: '/apps/chat/private-chat',
        name: 'apps-private-chat',
        component: () => import('@/views/apps/chat/Chat.vue'),
      },
      {
        path: '/apps/chat/group-chat',
        name: 'apps-group-chat',
        component: () => import('@/views/apps/chat/Chat.vue'),
      },
      {
        path: '/apps/chat/drawer-chat',
        name: 'apps-drawer-chat',
        component: () => import('@/views/apps/chat/DrawerChat.vue'),
      },
      {
        path: '/crafted/modals/general/invite-friends',
        name: 'modals-general-invite-friends',
        component: () => import('@/views/crafted/modals/general/InviteFriends.vue'),
      },
      {
        path: '/crafted/modals/general/view-user',
        name: 'modals-general-view-user',
        component: () => import('@/views/crafted/modals/general/ViewUsers.vue'),
      },
      {
        path: '/crafted/modals/general/upgrade-plan',
        name: 'modals-general-upgrade-plan',
        component: () => import('@/views/crafted/modals/general/UpgradePlan.vue'),
      },
      {
        path: '/crafted/modals/general/share-and-earn',
        name: 'modals-general-share-and-earn',
        component: () => import('@/views/crafted/modals/general/ShareAndEarn.vue'),
      },
      {
        path: '/crafted/modals/forms/new-target',
        name: 'modals-forms-new-target',
        component: () => import('@/views/crafted/modals/forms/NewTarget.vue'),
      },
      {
        path: '/crafted/modals/forms/new-card',
        name: 'modals-forms-new-card',
        component: () => import('@/views/crafted/modals/forms/NewCard.vue'),
      },
      {
        path: '/crafted/modals/forms/new-address',
        name: 'modals-forms-new-address',
        component: () => import('@/views/crafted/modals/forms/NewAddress.vue'),
      },
      {
        path: '/crafted/modals/forms/create-api-key',
        name: 'modals-forms-create-api-key',
        component: () => import('@/views/crafted/modals/forms/CreateApiKey.vue'),
      },
      {
        path: '/crafted/modals/wizards/two-factor-auth',
        name: 'modals-wizards-two-factor-auth',
        component: () => import('@/views/crafted/modals/wizards/TwoFactorAuth.vue'),
      },
      {
        path: '/crafted/modals/wizards/create-app',
        name: 'modals-wizards-create-app',
        component: () => import('@/views/crafted/modals/wizards/CreateApp.vue'),
      },
      {
        path: '/crafted/modals/wizards/create-account',
        name: 'modals-wizards-create-account',
        component: () => import('@/views/crafted/modals/wizards/CreateAccount.vue'),
      },
      {
        path: '/crafted/widgets/lists',
        name: 'widgets-list',
        component: () => import('@/views/crafted/widgets/Lists.vue'),
      },
      {
        path: '/crafted/widgets/statistics',
        name: 'widgets-statistics',
        component: () => import('@/views/crafted/widgets/Statistics.vue'),
      },
      {
        path: '/crafted/widgets/charts',
        name: 'widgets-charts',
        component: () => import('@/views/crafted/widgets/Charts.vue'),
      },
      {
        path: '/crafted/widgets/mixed',
        name: 'widgets-mixed',
        component: () => import('@/views/crafted/widgets/Mixed.vue'),
      },
      {
        path: '/crafted/widgets/tables',
        name: 'widgets-tables',
        component: () => import('@/views/crafted/widgets/Tables.vue'),
      },
      {
        path: '/crafted/widgets/feeds',
        name: 'widgets-feeds',
        component: () => import('@/views/crafted/widgets/Feeds.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('@/components/page-layouts/Auth.vue'),
    children: [
      {
        path: '/sign-in',
        name: 'sign-in',
        component: () => import('@/views/crafted/authentication/basic-flow/SignIn.vue'),
      },
      {
        path: '/sign-up',
        name: 'sign-up',
        component: () => import('@/views/crafted/authentication/basic-flow/SignUp.vue'),
      },
      {
        path: '/password-reset',
        name: 'password-reset',
        component: () => import('@/views/crafted/authentication/basic-flow/PasswordReset.vue'),
      },
    ],
  },
  {
    // the 404 route, when none of the above matches
    path: '/404',
    name: '404',
    component: () => import('@/views/crafted/authentication/Error404.vue'),
  },
  {
    path: '/embedView',
    component: () => import('@/views/admin/lms/embedView.vue'),
  },
  {
    path: '/500',
    name: '500',
    component: () => import('@/views/crafted/authentication/Error500.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404',
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

const whiteList = ['/sign-in']

router.beforeEach(async (to, from, next) => {
  const hasToken = JwtService.getToken()
  // console.log(hasToken)

  if (hasToken) {
    if (to.path === '/sign-in') {
      next({ path: '/' })
    } else {
      try {
        // reset config to initial state
        store.commit(Mutations.RESET_LAYOUT_CONFIG)
        store.dispatch(Actions.VERIFY_AUTH)
        store.dispatch('loadMenus')
        next()
        // Scroll page to top on every route change
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 100)
      } catch (error) {
        console.log(error)
        await store.dispatch('logout')
        next('/sign-in')
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next(`/sign-in`)
    }
  }

  // reset config to initial state
  // store.commit(Mutations.RESET_LAYOUT_CONFIG)

  // store.dispatch(Actions.VERIFY_AUTH)

  // store.dispatch('loadMenus')

  // Scroll page to top on every route change
  // setTimeout(() => {
  //   window.scrollTo(0, 0)
  // }, 100)
})

export default router
